// extracted by mini-css-extract-plugin
module.exports =  {"estimates":"Nich5UdDr8bgMpLKN928","icon":"Xsf3LHQAMBoIe340wLAL","label":"Uxmn8saDLCEAPsx8Bjpl","success":"s_YovGWqqgZcW6k2XpI6","sync":"MLAGV6D7OQENToQ35NQX"};